<template>
  <div class="page">
    <h1>Error 404</h1>
    <p>The Food You're Looking For Could Not Be Found!</p>
    <div class="link-section">
      <router-link class="home-link" :to="{ name: 'Home' }"
        >Let's Take You Home! <Arrow class="icon"
      /></router-link>
    </div>

    <!--
    <p>Error, Page Not Found, LOL!</p>
    -->
  </div>
</template>

<script>
import Arrow from "../assets/Icons/arrow-right-light.svg";

export default {
  name: "Error404",
  components: {
    Arrow,
  },
};
</script>

<style lang="scss" scoped>
.page {
  height: 100vh;
  background-image: url("../assets/background/background21.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  color: #fff;

  h1 {
    font-size: 70px;
    margin: 100px 0 30px 0;
  }

  p {
    font-size: 35px;
    margin-bottom: 20px;
  }

  .link-section {
    .home-link {
      font-size: 21px;
      color: #f1f1f1;
      text-decoration: none;
    }

    .icon {
      height: auto;
      width: 12px;
    }
  }
}
</style>
